import { string, object } from '@/shared/libs/yup';
import { nameSchema } from '@/app/form/fields/common/name';
import { dateSchema } from '@/app/form/fields/common/date';

export const createValidationSchema = () => object({
  project: nameSchema.required().label('Project name'),
  customer: nameSchema.required().label('Customer'),
  revisionNumber: string().required().label('Revision Number'),
  revisionDate: dateSchema.required().label('Revision Date'),
});